export interface Agreement {
  htmlText: string;
}
